import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/xing': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M162.7 210C160.9 213.3 137.5 254.4 92.6 333.5 87.7 341.8 81.8 346 74.9 346H9.8C2.1 346-2.3 338.5 1.3 331.6L70.3 210.3C70.5 210.3 70.5 210.2 70.3 210L26.4 134.4C22.1 126.6 26.7 120.3 34.9 120.3H100C107.3 120.3 113.3 124.4 118 132.5L162.7 210zM382.6 46.1L238.6 299.1V299.4L330.2 466C334.1 473.1 330.4 480.1 321.7 480.1H256.5C248.9 480.1 242.9 476.1 238.5 467.9L146.1 299.4C149.4 293.6 197.6 208.6 290.9 44.2 295.5 36.1 301.3 32 308.4 32H374.1C382.1 32 386.4 38.7 382.6 46.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/xing.js
// module id = wWbB
// module chunks = 144